import React from 'react';
import * as styles from './styles.scss';

const AVAILABLE_PAYMENTS_CARTS = {
    AE: <div className={`${styles.icon} ${styles.amex}`} />,
    DN: <div className={`${styles.icon} ${styles.diners}`} />,
    DI: <div className={`${styles.icon} ${styles.discover}`} />,
    JCB: <div className={`${styles.icon} ${styles.jcb}`} />,
    MI: <div className={`${styles.icon} ${styles.maestro}`} />,
    MC: <div className={`${styles.icon} ${styles.mastercard}`} />,
    CUP: <div className={`${styles.icon} ${styles.unionpay}`} />,
    VI: <div className={`${styles.icon} ${styles.visa}`} />,
};

const AvailablePaymentsList = () => (
    <div className={styles.cards}>
        <div className={`${styles.icon} ${styles.visa}`} />
        <div className={`${styles.icon} ${styles.mastercard}`} />
        <div className={`${styles.icon} ${styles.amex}`} />
        <div className={`${styles.icon} ${styles.discover}`} />
    </div>
);

export {
    AVAILABLE_PAYMENTS_CARTS
};

export default AvailablePaymentsList;
